export { default } from './QuestionAnswers';
